import { useParams } from "react-router";

import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Tooltip from "ds/components/Tooltip";
import useCanReviewIntentResourceOperation from "shared/IntentProject/access/useCanReviewIntentResourceOperation";
import useIntentProject from "shared/IntentProject/useIntentProject";
import { IntentResourceOperation, IntentResourceOperationState } from "types/generated";

import { showIntentProjectReviewDrawer } from "../../ReviewDrawer";

const IntentProjectOperationsTableRowActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const { intentProjectId } = useParams<{ intentProjectId: string }>();
  const { intentProject } = useIntentProject(intentProjectId);
  const canReview = useCanReviewIntentResourceOperation(intentProject);

  const isPendingReview = item.state === IntentResourceOperationState.PendingReview;
  const showReviewButton = isPendingReview && (canReview.result || !!canReview.message);

  const handleReview = () => {
    if (!intentProjectId) return;
    showIntentProjectReviewDrawer({ operation: item, intentProjectId });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <Box justify="end" align="center" gap="medium" fullWidth>
        {showReviewButton && (
          <Tooltip
            active={!canReview.result && !!canReview.message}
            on={(tooltipProps) => (
              <Button
                {...tooltipProps}
                variant="secondary"
                size="small"
                onPress={handleReview}
                disabled={!canReview.result}
              >
                Review
              </Button>
            )}
          >
            {canReview.message}
          </Tooltip>
        )}

        <DropdownMenuEllipsis tooltip="Operation actions">
          <CopyFieldDropdownMenuItem value={item.id} title="Copy Operation ID" />
          <CopyFieldDropdownMenuItem value={item.resourceID} title="Copy Resource ID" />
        </DropdownMenuEllipsis>
      </Box>
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableRowActionsCell;
